import { render, staticRenderFns } from "./AssociateOrders.vue?vue&type=template&id=bca07d02&"
import script from "./AssociateOrders.vue?vue&type=script&lang=js&"
export * from "./AssociateOrders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../home/ubuntu/albert_frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports